import { Component } from '@poa/core';
import { action, observable } from '@poa/state';
import React from 'react';
import { DateRangePicker } from 'react-dates';
import { ReactComponent as FilterToggle } from '../img/svgo/filter-tool.svg';
import { PrefetchSelect } from './profile-modal/tabs/profile-tab-form';
import { ACCESS_LEVEL } from '../store/auth/auth.constants';


export const PageModeCalendar = {
  accounts: 'accounts',
  operators: 'operators',
  clients: 'clients'
};

export const DateModeCalendar = {
  days: 'days',
  monthes: 'monthes',
};


class DashboardFilter extends React.Component {
  t; // injected by Poa

  static defaultProps = {
    state: {
      status: {
        selected: { value: 'none', label: 'нет' },
        options: []
      }
    },
    onStatusChange: () => {},
    onDatesChange: () => {},
    selectors: {},
    onPageModeChange: null
  };

  localState = observable({
    showNav: false
  });

  toggleNavItems = action(() => {
    this.localState.showNav = !this.localState.showNav;
  });

  focusedDateInput = observable(null);

  handleDatepickerFocusChange = focusedInput => this.focusedDateInput.set(focusedInput);

  renderStatusOption = (d, i) => {
    const { state, onStatusChange } = this.props;
    return this.renderOption(d, i, state.status.selected, onStatusChange);
  };

  renderOption(d, i, selected, onClick) {
    let className = 'common-filter__btn';

    if (selected === d) {
      className += ' is-active';
    }
    return (
      <button key={i} className={className} onClick={() => onClick(d)}>
        {d.label}
      </button>
    );
  }


  render() {
    const {
      state,
      onDatesChange,
      withoutDatesChange,
      onPageModeCalendarChange,
      onDateModeCalendarChange,
    } = this.props;

    const isManagerOrAgency =
    this.store.auth.accessLevel === ACCESS_LEVEL.agency ||
    this.store.auth.accessLevel === ACCESS_LEVEL.manager;

    return (
      <div className='filters' style={{background: "linear-gradient(175deg, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%)"}}>
        <div className='filter-icon' onClick={this.toggleNavItems}>
          <FilterToggle />
        </div>
        <div className={`filter-list  ${this.localState.showNav && 'active'}`}>
          <div className='filters__inner inner'>
            {!withoutDatesChange &&
              <div className='filters__left'>
                {!withoutDatesChange && (
                  <div className='filter'>
                    <span className='filter__label' style={{color: "#fff"}}>{this.t('period')}</span>
                    <DateRangePicker
                      disabled={this.props.datesDisabled}
                      startDateId='2'
                      endDateId='2'
                      isOutsideRange={() => false}
                      startDate={state.startDate}
                      startDatePlaceholderText={this.t('from')}
                      endDate={state.endDate}
                      endDatePlaceholderText={this.t('to')}
                      onDatesChange={onDatesChange}
                      focusedInput={this.focusedDateInput.get()}
                      onFocusChange={this.handleDatepickerFocusChange}
                      customArrowIcon='-'
                      minimumNights={0}
                      hideKeyboardShortcutsPanel={true}
                    />
                  </div>
                )}

              {(isManagerOrAgency)? (
                <div className='filter team-lead-filter'>
                  <PrefetchSelect
                          editMode={true}
                          type='teamleads'
                          current={state.teamLead}
                          AccountId={null}
                          onChange={value => (state.teamLead = value ? value : null)}
                        />
                </div>
              ) : null}
              </div>
            }
            { (onPageModeCalendarChange || onDateModeCalendarChange) &&
            <div className='filters__right'>
                            {onPageModeCalendarChange ? (
                <div className='filter'>
                  <div className='trigger-dashboard'>
                    <label className='trigger-dashboard__item' style={{ minWidth: 80 }}>
                      <input
                        className='trigger-dashboard__input'
                        type='radio'
                        name='trigger-pagemode'
                        value={PageModeCalendar.accounts}
                        checked={this.props.currentPageMode === PageModeCalendar.accounts}
                        onChange={onPageModeCalendarChange}
                      />
                      <span className='trigger__text'>Анкеты</span>
                    </label>
                    <label className='trigger-dashboard__item' style={{ minWidth: 80 }}>
                      <input
                        className='trigger-dashboard__input'
                        type='radio'
                        name='trigger-pagemode'
                        value={PageModeCalendar.operators}
                        checked={this.props.currentPageMode === PageModeCalendar.operators}
                        onChange={onPageModeCalendarChange}
                      />
                      <span className='trigger__text'>Операторы</span>
                    </label>
                    {this.store.auth.accessLevel === ACCESS_LEVEL.agency ? (
                    <label className='trigger-dashboard__item' style={{ minWidth: 80 }}>
                      <input
                        className='trigger-dashboard__input'
                        type='radio'
                        name='trigger-pagemode'
                        value={PageModeCalendar.clients}
                        checked={this.props.currentPageMode === PageModeCalendar.clients}
                        onChange={onPageModeCalendarChange}
                      />
                      <span className='trigger__text'>Клиенты</span>
                    </label>
                    ) : null}
                  </div>
                </div>
              ) : null}
              {onDateModeCalendarChange ? (
                <div className='filter'>
                  <div className='trigger-dashboard'>
                    <label className='trigger-dashboard__item' style={{ minWidth: 80 }}>
                      <input
                        className='trigger-dashboard__input'
                        type='radio'
                        name='trigger-datemode'
                        value={DateModeCalendar.days}
                        checked={this.props.currentDateMode === DateModeCalendar.days}
                        onChange={onDateModeCalendarChange}
                      />
                      <span className='trigger__text'>Дни</span>
                    </label>
                    <label className='trigger__item' style={{ minWidth: 80 }}>
                      <input
                        className='trigger-dashboard__input'
                        type='radio'
                        name='trigger-datemode'
                        value={DateModeCalendar.monthes}
                        checked={this.props.currentDateMode === DateModeCalendar.monthes}
                        onChange={onDateModeCalendarChange}
                      />
                      <span className='trigger__text'>Месяцы</span>
                    </label>
                  </div>
                </div>
              ) : null}
            </div>
            }
            {this.props.render ? this.props.render() : null}
          </div>
        </div>
      </div>
    );
  }
}

export default Component({ namespaces: ['dashboardFilter'] })(DashboardFilter);
